import React from 'react'
import { WalletWithPurpleBgIcon } from '../../../assets/images';

type AppProps={
    data:any;
    getDataObject:(data:any,title:string)=>JSX.Element
    }

const PaymentDetails = ({data,getDataObject}:AppProps) => {
  return (
    <div>
      {data?.payment_changes?.length > 0 ? (
              <div>
                {data?.payment_changes?.map((paymentChange: any) => {
                  return (
                    paymentChange?.changes?.length>0 ? 
                    <div className="mt-3 border audit-card">
                      <div className=" audit-header">
                        <img src={WalletWithPurpleBgIcon} alt="wallet" />
                        <div className='d-flex flex-column'>
                        <span className="header-card payment">
                          Payment Details
                        </span>
                        <span className='payment-sub-heading'>
                          {paymentChange?.name?.length>20 ? paymentChange?.name?.slice(0,20) + "..." : paymentChange?.name}
                        </span>
                        </div>
                      
                      </div>

                      {paymentChange?.changes?.map(
                        (item: any, index: number) => {
                          if (item) {
                            return (
                              <>
                                <div className="pt-3 pr-3 pl-3">
                                  {getDataObject(
                                    paymentChange?.changes,
                                    item?.title
                                  )}
                                </div>
                                {index < paymentChange.changes?.length - 1 ? (
                                  <div className="line mt-2 mb-1"></div>
                                ) : null}
                              </>
                            );
                          }
                        }
                      )}
                    </div> : null
                  );
                })}
              </div>
            ) : null}
    </div>
  )
}

export default PaymentDetails
